/* global G */

/**
 * Cancels an ongoing upload.
 *
 * @param {Gaia.Web.Application} app  the Platform Web Application
 */
const fn = app => ({ detail }) => {
  const adapter = app[G.ADAPTER][G.ATTACHMENT]
  const eventBus = app[G.ADAPTER][G.EVENTS]
  const { key, parent } = detail[G.DATA] || {}

  const { uploads } = adapter[G.STATE]
  const entry = uploads.find(e => e.key === key && e.parent === parent)

  if (!entry) return

  entry.readHandler && eventBus.remove(entry.readEventType, entry.readHandler)
  entry.abort?.()
  entry.url && URL.revokeObjectURL(entry.url)

  const index = uploads.indexOf(entry)
  index >= 0 && uploads.splice(index, 1)

  eventBus.dispatch(eventBus.type(G.ATTACHMENT, G.PROGRESS), { [G.DATA]: uploads })
}

export default fn
